module.exports = __webpack_public_path__ + "static/media/bg-card-service-1.d3ce92e3.gif";